import { Fragment, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import 'dayjs/locale/en';
import calendar from 'dayjs/plugin/calendar';
import { Row, Container } from 'react-bootstrap';
import { Flex, Box } from 'theme-ui';

const PendingContainer = () => {
  const { t, i18n } = useTranslation();
  const { trackingDetails } = useContext(AppContext);
  dayjs.extend(calendar);
  dayjs.locale(i18n.language);
  return (
    <Fragment>
      {trackingDetails?.announcement && (
        <Flex sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px' }}>
          <Box className="announcement-box">
            <span>⚠️</span>
            <span className="blink-text">{trackingDetails?.announcement}</span>
          </Box>
        </Flex>
      )}
      <Container>
        <Row className="home_container">
          <div className="summary_container">
            <div className="summary_container--header">
              <p style={{ marginBottom: 10 }}>{t('tracking_number')}</p>
              <h3 style={{ marginBottom: 40 }}>{trackingDetails?.package?.externalPackageId}</h3>
            </div>

            <p style={{ marginBottom: 10 }}>{t('delivery_time')}</p>
            {trackingDetails?.eta?.lowerBound && trackingDetails?.eta?.upperBound ? (
              <h3
                style={{
                  marginBottom: 40
                }}
              >
                {dayjs(trackingDetails?.eta?.lowerBound || new Date()).calendar(null, {
                  sameDay: `[${t('delivery_today')}, ]`,
                  nextDay: `[${t('delivery_tomorrow')}, ]`,
                  lastDay: `[${t('delivery_today')}, ]`,
                  nextWeek: 'YYYY-MM-DD, ',
                  lastWeek: `[${t('delivery_today')}, ]`,
                  sameElse: 'YYYY-MM-DD, '
                })}
                {dayjs(trackingDetails?.eta?.lowerBound || new Date(Date.now() - 5 * 60 * 1000)).format('HH:mm') +
                  ' - ' +
                  dayjs(trackingDetails?.eta?.upperBound || new Date(Date.now() + 5 * 60 * 1000)).format('HH:mm')}
              </h3>
            ) : (
              <h3
                style={{
                  marginBottom: 40,
                  fontSize: '18px'
                }}
              >
                {t('eta.eta_error')}
              </h3>
            )}
            <p>{t('delivery_summary')}</p>
          </div>
        </Row>
      </Container>
    </Fragment>
  );
};

export default PendingContainer;
